import { LeafAccordionPanel } from "./accordion-panel.component.js";
customElements.define("leaf-accordion-panel", LeafAccordionPanel);
export {
  LeafAccordionPanel
};
//# sourceMappingURL=accordion-panel.js.map
